<template>
  <aside :class="$style.PWAside">
    <header :class="$style.PWAsideHeader">
      <h1 :class="$style.PWAsideHeaderTitle">
        {{ title }}
      </h1>
      <PWStepper
        v-model="stepValue"
        :steps="steps"
      />
    </header>
    <div :class="$style.PWAsideBody">
      <slot />
    </div>
    <footer :class="$style.PWAsideFooter">
      <slot name="footer" />
    </footer>
  </aside>
</template>

<script>
import PWStepper from '~/components/_ui/Steppers/PWStepper.vue'

export default {
  components: {
    PWStepper
  },
  props: {
    title: {
      type: String,
      default: 'Призыв к действию 1'
    },
    step: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => ([
        { label: 'Дизайн' },
        { label: 'Настройки' }
      ])
    }
  },
  computed: {
    stepValue: {
      get () { return this.step },
      set (val) { this.$emit('update-step', val) }
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.PWAside {
  position: sticky;
  top: 32px;
  right: 32px;
  width: 420px;
  height: 100%;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  box-shadow: 0 2px 16px 1px rgba(89, 104, 143, 0.06);
  border-radius: 8px;
  color: var(--primary);
}

.PWAsideHeader {
  position: sticky;
  z-index: 9;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 17px;
  width: 100%;
  border-bottom: 1px solid var(--grey-200);
  background-color: var(--white);
}

.PWAsideHeaderTitle {
  all: unset;
  box-sizing: border-box;
  display: inline;
  color: currentColor;
  margin: 24px 24px 0 24px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @include mixins.h1;
}

.PWAsideFooter {
  margin-top: auto;
  padding: 16px 24px;
  border-top: 1px solid var(--grey-200);
}
</style>
